module.exports = __webpack_public_path__ + "static/steps-topper-3-1ad2e762876ba01fcad714600c0b3d29.png";